<template>
  <transition name="fade">
    <div v-if="!state.loading">  
    <div class="p-0 m-0 card mb-5 mb-xxl-8" >
        <div class="card-header pb-0">
            <div class="card-title">
              <div class="card-title">
                <i class="bi bi-arrow-left-short fs-2tx text-primary text-hover-gray-600 cursor-pointer me-4" @click="close()"></i>
                <div class="fs-4 text-uppercase text-gray-800" >{{ state.title }}</div>
              </div>
            </div>
            <div class="d-flex align-items-center m-0" v-if="!modeDisabled()">
              <el-popconfirm title="Supprimer cet état mensuel ?" @confirm="removeEtatEmp()"  :confirm-button-text="$t('Oui')" :cancel-button-text="$t('Non')"  icon-color="danger">
                <template #reference>
                  <i class="bi bi-trash3 fs-1 text-danger text-hover-gray-600 cursor-pointer me-8" ></i>
                </template>
              </el-popconfirm>
            </div>
        </div>
      </div>

      <div class="card mb-5 mb-xxl-8 mx-4 mx-md-8" >
          <div class="card-body pt-2 pt-md-5 pb-0">
              <div class="row mb-5">
                  <label class="col-lg-4 col-form-label fw-semobold fs-6">Mois de réference</label>
                  <div class="col-lg-8 col-12 fv-row">
                      <input disabled type="text" class="form-control ps-4 text-center fs-4" v-model="state.rEtat.eem_libelle"/>
                  </div>
              </div>
          </div>
      </div>

      <div class="card mb-5 mb-xxl-8 mx-4 mx-md-8" >
          <div class="card-body pt-2 pt-md-5 pb-0">
            <div class="row mb-5">
              <label class="col-lg-4 col-form-label fw-semobold fs-6 required">Avez-vous envoyé vos notes de frais pour le mois courant ? :</label>
              <div class="col-lg-8 col-12 fv-row">
                <div class="d-flex gap-3">
                  <div class="form-check">
                    <input
                      :disabled="modeDisabled()" 
                      type="radio" 
                      class="form-check-input" 
                      id="n2f-oui" 
                      name="n2f"
                      value="1" 
                      @click="checkN2f(1)"
                    />
                    <label class="form-check-label fw-semibold" for="n2f-oui">Oui</label>
                  </div>
                  <div class="form-check">
                    <input 
                      :disabled="modeDisabled()"
                      type="radio" 
                      class="form-check-input" 
                      id="n2f-non" 
                      name="n2f" 
                      value="0" 
                      @click="checkN2f(0)"
                    />
                    <label class="form-check-label fw-semibold" for="n2f-non">Non</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
      </div>

      <div class="card mb-5 mb-xxl-8 mx-4 mx-md-8">
          <div class="card-body pt-2 pt-md-5 pb-0">
            <div class="row mb-5">
                <label class="col-lg-4 col-form-label fw-semobold fs-6 required">Total de repas client :</label>
                <div class="col-lg-8 col-12 fv-row">
                    <input type="number" :disabled="modeDisabled()" class="form-control ps-4 text-center fs-4" v-model="state.rEtat.eem_repas_mois" placeholder="ex. 3"/>
                </div>
            </div>
            <div class="row mb-5">
              <label class="col-lg-4 col-form-label fw-semobold fs-6 required">Congés saisis ? :</label>
              <div class="col-lg-8 col-12 fv-row">
                <div class="d-flex gap-3">
                  <div class="form-check">
                    <input
                      :disabled="modeDisabled()" 
                      type="radio" 
                      class="form-check-input" 
                      id="conges-oui" 
                      name="conges" 
                      value="1" 
                      v-model="state.rEtat.eem_x_conges"
                    />
                    <label class="form-check-label fw-semibold" for="conges-oui">Oui</label>
                  </div>
                  <div class="form-check">
                    <input 
                      :disabled="modeDisabled()"
                      type="radio" 
                      class="form-check-input" 
                      id="conges-non" 
                      name="conges" 
                      value="0" 
                      v-model="state.rEtat.eem_x_conges"
                    />
                    <label class="form-check-label fw-semibold" for="conges-non">Non</label>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="state.rEtat.emp_x_voiture == 1">
              <div class="row mb-5">
                <label class="col-lg-4 col-form-label fw-semobold fs-6 required">Compteur kilométrique :</label>
                <div class="col-lg-8 col-12 fv-row">
                    <input type="number" :disabled="modeDisabled()" class="form-control ps-4 text-center fs-4" v-model="state.rEtat.eem_kms_mois" placeholder="ex. 1000"/>
                </div>
              </div>
              <div class="row mb-5">
                <label class="col-lg-4 col-form-label fw-semobold fs-6 required">Usage pro (%) :</label>
                <div class="col-lg-8 col-12 fv-row">
                    <input 
                      type="number" 
                      :disabled="modeDisabled()" 
                      class="form-control ps-4 text-center fs-4" 
                      v-model="state.rEtat.eem_usage_voiture_pro" 
                      :placeholder="getUsagePersoPlaceholder()"
                    />
                </div>
              </div>
              <div class="row mb-5">
                <label class="col-lg-4 col-form-label fw-semobold fs-6 required">Usage perso (%) :</label>
                <div class="col-lg-8 col-12 fv-row">
                    <input 
                      type="number" 
                      :disabled="modeDisabled()" 
                      class="form-control ps-4 text-center fs-4" 
                      v-model="state.rEtat.eem_usage_voiture_perso" 
                      :placeholder="getUsagePersoPlaceholder()"
                    />
                </div>
              </div>
            </div>
            <div class="row mb-5">
                <label class="col-lg-4 col-form-label fw-semobold fs-6">Total d'heures HNO :</label>
                <div class="col-lg-8 col-12 fv-row">
                    <input type="number" :disabled="modeDisabled()" class="form-control ps-4 text-center fs-4" v-model="state.rEtat.eem_tot_heures_hno" placeholder="ex. 1,5"/>
                </div>
            </div>
            <div class="row mb-5">
                <label class="col-lg-4 col-form-label fw-semobold fs-6">Commentaires HNO :</label>
                <div class="col-lg-8 col-12 fv-row">
                    <textarea class="form-control form-control-solid rounded-3" :disabled="modeDisabled()" rows="2" v-model="state.rEtat.eem_commentaire_hno" placeholder="Client: 011 client test, 02/11/2025, 18h00 - 20h00.&#10;Client: Customer test, 05/11/2025, 01h00 - 03h00."/>
                </div>
            </div>          
          </div>
      </div>

      <div v-if="state.rEtat.eem_status!='Validé'" class="card mb-5 mb-xxl-8 mx-4 mx-md-8" >
          <div class="card-header pb-0 mx-auto">
                            
              <div v-if="state.rEtat.eem_status=='Brouillon' || state.rEtat.eem_status=='Refusé'" class="m-0 m-md-6 mb-6 text-center w-100 w-md-auto mw-md-450px">
                <template v-if="state.rEtat">
                  <el-popconfirm title="Souvegarder votre saisie? Elle restera modifiable" @confirm="sendEtat('Brouillon')"  :confirm-button-text="$t('Oui')" :cancel-button-text="$t('Non')"  icon-color="info">
                    <template #reference>
                      <button class="btn btn-primary me-2 w-100 mb-3">
                        <i class="bi bi-send fs-2 text-white text-hover-gray-600 cursor-pointer me-4" ></i>
                        Sauvegarder ma saisie sans envoyer les informations
                      </button>
                    </template>
                  </el-popconfirm>
                </template>

                <template v-if="state.rEtat">
                  <el-popconfirm title="Transmettre cet état mensuel ? Il deviendra non modifiable" @confirm="sendEtat('En attente de validation')"  :confirm-button-text="$t('Oui')" :cancel-button-text="$t('Non')"  icon-color="danger">
                    <template #reference>
                      <button class="btn btn-success me-2 w-100">
                        <i class="bi bi-send fs-2 text-white text-hover-gray-600 cursor-pointer me-4" ></i>
                        Valider la saisie et envoyer les informations
                      </button>
                    </template>
                  </el-popconfirm>
                </template>
              </div> 

              <div v-if="state.rEtat.eem_status=='En attente de validation'" class="m-0 m-md-6 mb-6 text-center w-100 w-md-auto mw-md-450px">
  
                <template v-if="state.rEtat && state.allRest && state.allRest.length == 0">
                  <el-popconfirm title="Valider ces informations ?" @confirm="sendEtat('Validé')"  :confirm-button-text="$t('Oui')" :cancel-button-text="$t('Non')"  icon-color="danger">
                    <template #reference>
                      <button class="btn btn-success me-2 w-100">
                        <i class="bi bi-check2 fs-1 text-white text-hover-gray-600 cursor-pointer me-4" ></i>
                        Valider les informations envoyées par le collaborateur
                      </button>
                    </template>
                  </el-popconfirm>
                </template>

                <template v-if="state.rEtat && state.allRest && state.allRest.length == 0">
                  <el-popconfirm title="Refuser ces informations ?" @confirm="sendEtat('Refusé')"  :confirm-button-text="$t('Oui')" :cancel-button-text="$t('Non')"  icon-color="danger">
                    <template #reference>
                      <button class="btn btn-danger me-2 w-100 mt-3">
                        <i class="bi bi-file-earmark-x fs-2 text-white text-hover-gray-600 cursor-pointer me-4" ></i>
                        Refuser les informations envoyées par le collaborateur
                      </button>
                    </template>
                  </el-popconfirm>
                </template>

              </div>
          </div>
      </div>  
    </div>
    <div v-else v-loading="true" style="position: absolute; top: 50%; left: 50%"></div>
  </transition>

</template>
  
  <script lang="ts">
  import { defineComponent, ref, onMounted, reactive } from "vue";
  import mAxiosApi from "@/api";
  import { FileService } from "@/core/services/FileService";
  import * as moment from "moment"
  import { ElMessage, ElMessageBox } from "element-plus";
   
  export default defineComponent({
    name: "General",
    components : {
    },
    props : {
      idEtat : Number,
      isOpen : Number,
      apiName : String,
    },
    setup(props, { emit }) {

    const dialogImageUrl = ref('')
    const dialogVisible = ref(false)
    const disabled = ref(false)

    const state = reactive({
        drawerAddItem : 0,
        masqueSubStitle : 0,
        rEtat : {} as any,
        title : 'Nouvelle saisie',
        idDepense : 0,
        idFolder: 0,
        refresh : 0,
        idEtat : 0,
        allRest: {} as any,
        loading: true,
        comsHisto: false,
        n2fEnvoyé: 0
    });
    
    onMounted(async() => {
      
      const allRest = await mAxiosApi.prototype.getAxios("/getPermissions");
      state.allRest =  allRest.results.filter(
          (item: any) =>item.per_code_permission == 'ERP_TRAITE_N2F'
      );

      if (!props.isOpen) return false;
      if (props.idEtat as any > 0) {
          const getEtatEmp = await mAxiosApi.prototype.getAxios("/"+ props.apiName +"/" + props.idEtat);
          // const getFolder = await N2FfileService.createFolder(("Etat mensuel " + getEtatEmp.results[0].eem_seq));
          // state.idFolder = getFolder
          state.rEtat = getEtatEmp.results[0];
          console.log('etat :', state.rEtat);
          if (((state.rEtat.eem_status == 'Brouillon' || state.rEtat.eem_status == 'Refusé')) ||
          ((state.rEtat.eem_status != 'Validé'))) {
            state.title = "Modifier l'état mensuel";
          }else{
            state.title = "Afficher l'état mensuel";
          }
      } else{
        const newEtatEmp = await mAxiosApi.prototype.getAxios("/newEtatEmp");
        // const newFolder = await N2FfileService.createFolder(("Etat mensiel " + newEtatEmp.results.eem_seq));
        // state.idFolder = newFolder;
        const getEtatEmp = await mAxiosApi.prototype.getAxios("/"+ props.apiName +"/" + newEtatEmp.results.eem_seq);
        state.rEtat = getEtatEmp.results[0];
        refreshParent();
      }
      
      state.idEtat = state.rEtat.eem_seq;

      if (!modeDisabled() && 
          (!state.rEtat.eem_usage_voiture_perso || state.rEtat.eem_usage_voiture_perso === '') && 
          state.rEtat.eem_usage_voiture_perso_precedent) {
        state.rEtat.eem_usage_voiture_perso = state.rEtat.eem_usage_voiture_perso_precedent;
      }

      if (!modeDisabled() && 
          (!state.rEtat.eem_usage_voiture_pro || state.rEtat.eem_usage_voiture_pro === '') && 
          state.rEtat.eem_usage_voiture_perso_precedent) {
        state.rEtat.eem_usage_voiture_pro = state.rEtat.eem_usage_voiture_pro_precedent;
      }

      state.loading = false;

    });

    const close = () => {
      emit("closeEtatAddEdit", 0);
    };

    

    const removeEtatEmp = () => {
      const rEtat = {
        eem_seq: state.rEtat.eem_seq,
      };

      mAxiosApi.post("/deleteEtatEmp", rEtat)
      .then(() => {
        refreshParent();
        close();
      })

    };

    const sendEtat = (status) => {

      if(state.rEtat.emp_x_voiture == 1 && (status == 'En attente de validation' || status == 'Refusé')){
        const pctTotal = Math.fround(state.rEtat.eem_usage_voiture_perso) + Math.fround(state.rEtat.eem_usage_voiture_pro);
        
        if(pctTotal != 100){
          ElMessage({
            type: 'error',
            message: "Total n'est pas égal à 100%, merci de refaire la saisie des répartitions",
          })
          return
        }
      }

      if(state.rEtat.emp_x_voiture == 1 && (status == 'En attente de validation' || status == 'Refusé')) {
        if (state.rEtat.eem_kms_mois_precedent > state.rEtat.eem_kms_mois) {
          ElMessage({
            type: 'error',
            message: "Le kilometrage pour le mois ne peut pas etre inferieur au mois précedent : " + state.rEtat.eem_kms_mois_precedent,
          })
          return
        }
      }

      if(state.rEtat.eem_x_conges != 1){
        ElMessage({
          type: 'error',
          message: "Si vous avez pris des congés pendant cette période pensez à bien saisir vos indisponibilités svp",
        })
      }

      if(state.rEtat.eem_tot_heures_hno > 0 && (!state.rEtat.eem_commentaire_hno || state.rEtat.eem_commentaire_hno.trim() === '') && (status == 'En attente de validation' || status == 'Refusé')){
        ElMessage({
          type: 'error',
          message: "Veuillez saisir les détais de vos heures HNO dans le champ commentaires svp. ",
        })
        return
        
      }

      const rEtat = {
        eem_seq: state.rEtat.eem_seq,
        eem_repas_mois: state.rEtat.eem_repas_mois,
        eem_kms_mois: state.rEtat.eem_kms_mois,
        eem_usage_voiture_perso: state.rEtat.eem_usage_voiture_perso,
        eem_usage_voiture_pro: state.rEtat.eem_usage_voiture_pro,
        eem_x_conges: state.rEtat.eem_x_conges,
        eem_tot_heures_hno: state.rEtat.eem_tot_heures_hno,
        eem_commentaire_hno: state.rEtat.eem_commentaire_hno,
        eem_status: status
      };

      mAxiosApi.post("/sendEtat", rEtat)
      .then(() => {
        refreshParent();
        close();
      })

    };

    const getUsagePersoPlaceholder = () => {
      if (state.rEtat.eem_usage_voiture_perso_precedent) {
        return `ex. 50 (précédent: ${state.rEtat.eem_usage_voiture_perso_precedent}%)`;
      }
      return "ex. 50";
    };

    
    const refreshParent = () => {
      emit("refresh", 1);
    };

    const refresh = async () => {
      const getEtatEmp = await mAxiosApi.prototype.getAxios("/"+ props.apiName +"/" + state.idEtat);
      state.rEtat = getEtatEmp.results[0];
      state.refresh = state.refresh +1;
      refreshParent();
    };

    const modeDisabled = () => {
      if (state.rEtat.eem_status=='Brouillon' || state.rEtat.eem_status=='Refusé') return false;
      return true;
    };

    const formatDate = (date) => {
      return moment.default(date).format("DD/MM/YYYY");
    }

    const checkN2f = (int) => {
      const value = Number(int);
      state.n2fEnvoyé = value === 1 ? 1 : 0;

      if (state.n2fEnvoyé == 1) {
        getRepas();
      }
    }

    const getRepas = async() => {
      const allRepas = await mAxiosApi.prototype.getAxios("/getRepas/" + state.rEtat.eem_knum_employe);
      state.rEtat.eem_repas_mois =  allRepas.results[0].total_jours   
    }

      return {
          disabled,
          dialogImageUrl,
          dialogVisible,
          state,
          close,
          refreshParent,
          refresh,
          removeEtatEmp,
          sendEtat,
          modeDisabled,
          formatDate,
          getUsagePersoPlaceholder,
          checkN2f,
          getRepas
      };
    },
  });
  </script>